import { convertMarkingToJCE } from 'chessboard/plugins/markings/model/convert-marking-to-jce';
import type { Markings, ModifyJCEMarkingResult } from 'chessboard/plugins/markings/config/types';
import type JCE from '@chesscom/js-chess-engine';
import { Annotations } from 'chessboard/model/annotation/types';
import type { GameAPI } from 'chessboard/types';
import type { API } from 'api/config/types';
import { nodeTargetSquare } from 'api/move/model/node-target-square';

/**
 * Remove a marking from a node.
 */
export function removeFromJCENode(
  game: JCE.Game,
  marking: Markings.KeyedModel,
  api: API.Extended | GameAPI,
): ModifyJCEMarkingResult {
  const jceMarking = convertMarkingToJCE(marking);

  const { node: markingNode } = marking;
  const isCurrentNode = typeof markingNode !== 'object';
  const targetIds = isCurrentNode ? game.ids() : markingNode;

  game.mark(jceMarking, true, targetIds.move, targetIds.line);

  // eslint-disable-next-line no-underscore-dangle
  const targetNode = game._getPos(targetIds.move, targetIds.line);

  const effect = Annotations.Effects[marking.data.type];
  const isMarkOnMoveNode = targetNode && nodeTargetSquare(targetNode) === marking.data.square;
  const theSameAnnotation = targetNode?.annotation === effect;

  if (effect && isMarkOnMoveNode && theSameAnnotation) {
    api.updateNode(targetIds, { annotation: '', isSync: true });
  }

  return {
    changes: {
      operation: 'remove',
      command: marking,
    },
    ids: targetIds,
  };
}
